import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { Plann3rStore } from '../../store/types'
import './styles.scss'

const Footer: FC = () => {
  const { colors, show } = useSelector((state: Plann3rStore) => state.general.footer)

  const footerStyle = {
    color: colors.secondary,
    backgroundColor: colors.primary,
  }

  return (
    <footer className="footer" id="footer" style={footerStyle}>
      <div className="footerSpacer" />
      {show && (
        <div className="container">
          <div className="content has-text-centered">
            <p>
              Plann3r
            </p>
          </div>
        </div>
      )}
    </footer>
  )
}

export default Footer
